import {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon, CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

import {CreditApplicationSource} from "../../application/utils/CreditApplicationSource";
import {GreyInfoTable} from "../../atoms/GreyInfoTable";
import {useCreditPaywallAbTest} from "../hooks/use_credit_paywall_ab_test";
import {CreditModalEvent, ModalEventSource} from "../tracking/analytics/credit_modal_event";
import {CreditCalculatorGTMEvent} from "../tracking/credit_gtm";
import {sendCreditEvent} from "../tracking/send_credit_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";
import {ICreditData, ICreditRatingData} from "../types/ICreditData";
import {getCreditInfo} from "../utils/get_credit_info";
import {CreditCalculatorForm} from "./CreditCalculatorForm";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    submitData: ICreditData | ICreditRatingData;
    gtmEvent?: CreditCalculatorGTMEvent;
    algolyticData: {type: CreditAlgolyticsViewType; source: ModalEventSource};
}

export const CreditApplicationModal = (props: IProps) => {
    const [applicationSuccess, setApplicationSuccess] = useState(false);
    const {unlockOffers, areOffersUnlocked, isPaywallVariant} = useCreditPaywallAbTest();

    useEffect(() => {
        if (!props.isOpen) {
            const timeout = setTimeout(() => {
                // reset steps
                setApplicationSuccess(false);
            }, 300); // wait for animation to finish

            return () => {
                clearTimeout(timeout);
            };
        }
    }, [props.isOpen]);

    const creditInfoTable = getCreditInfo(props.submitData);

    const onClose = (closedByButton?: boolean) => {
        props.onClose();
        if (!applicationSuccess) {
            CreditModalEvent({
                sent: closedByButton ? false : null,
                source_id: props.algolyticData.source,
                view_type: props.algolyticData.type
            });
        }
    };

    const onAfterSend = (isSuccess: boolean) => {
        CreditModalEvent({
            sent: true,
            source_id: props.algolyticData.source,
            view_type: props.algolyticData.type
        });

        if (props.gtmEvent) {
            sendCreditEvent(props.gtmEvent);
        }

        if (isSuccess !== applicationSuccess) {
            setApplicationSuccess(isSuccess);
        }

        // Unlock credit offers after successful form submission
        if (isSuccess) {
            unlockOffers();
        }
    };

    return (
        <Modal isOpen={props.isOpen} onModalClose={() => onClose()} className={modalStyle}>
            {applicationSuccess ? (
                <>
                    <Modal.Header />
                    <Modal.Content>
                        <div className={successContentStyle} data-testid={CREDIT_PAGES_IDS.COMMON.CREDIT_APPLICATION_MODAL}>
                            <div className={successTextStyle}>
                                <BrandCheckboxCheckedIcon wrapperSize="10" size="10" wrapperColor="var(--colors-primary)" />
                                <Text variant="headline_3" as="p">
                                    Twoje zapytanie zostało wysłane
                                </Text>
                            </div>
                            <Button variant="filled_primary" className={buttonStyle} onClick={() => onClose()}>
                                ok
                            </Button>
                        </div>
                    </Modal.Content>
                </>
            ) : (
                <>
                    <Modal.Header showCloseButton={false} className={headerStyle}>
                        <div className={headerContentStyle}>
                            {!areOffersUnlocked && isPaywallVariant ? (
                                <>
                                    <Text variant="headline_6">Zobacz pełne warunki kredytu</Text>
                                    <Text variant="body_copy_2" color="var(--colors-gray-700)">
                                        Podaj swoje dane, aby odkryć oprocentowanie, RRSO i szczegóły oferty dopasowane do Ciebie.
                                    </Text>
                                </>
                            ) : (
                                <>
                                    <Text variant="headline_6">Umów się na rozmowę</Text>
                                    <Text variant="body_copy_2" color="var(--colors-gray-700)">
                                        Skorzystaj z bezpłatnej porady kredytowej
                                    </Text>
                                </>
                            )}
                            <div onClick={() => onClose(true)} className={closeStyle}>
                                <CloseIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Content className={contentStyle}>
                        {creditInfoTable.length > 0 && <GreyInfoTable infoItems={creditInfoTable} />}

                        <CreditCalculatorForm
                            submitData={props.submitData}
                            onAfterSend={onAfterSend}
                            source={CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT}
                        />
                    </Modal.Content>
                </>
            )}
        </Modal>
    );
};

const modalStyle = css({
    overflow: "visible",
    padding: "2 0",
    md: {
        padding: 2,
        width: "55rem"
    }
});

const headerStyle = css({
    position: "relative"
});

const headerContentStyle = css({
    marginTop: 2,
    paddingRight: 5
});

const contentStyle = css({
    overflow: "visible"
});

const closeStyle = css({
    position: "absolute",
    padding: 2,
    top: 0,
    right: 0,
    cursor: "pointer"
});

const successContentStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
    gap: 5
});

const successTextStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});

const buttonStyle = css({
    width: "100%"
});
import {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon, CloseIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/e2e-test-utils";

import {CreditApplicationSource} from "../../application/utils/CreditApplicationSource";
import {GreyInfoTable} from "../../atoms/GreyInfoTable";
import {useCreditPaywallAbTest} from "../hooks/use_credit_paywall_ab_test";
import {CreditModalEvent, ModalEventSource} from "../tracking/analytics/credit_modal_event";
import {CreditCalculatorGTMEvent} from "../tracking/credit_gtm";
import {sendCreditEvent} from "../tracking/send_credit_event";
import {CreditAlgolyticsViewType} from "../tracking/types/CreditAlgolyticsViewType";
import {ICreditData, ICreditRatingData} from "../types/ICreditData";
import {getCreditInfo} from "../utils/get_credit_info";
import {CreditCalculatorForm} from "./CreditCalculatorForm";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    submitData: ICreditData | ICreditRatingData;
    gtmEvent?: CreditCalculatorGTMEvent;
    algolyticData: {type: CreditAlgolyticsViewType; source: ModalEventSource};
}

export const CreditApplicationModal = (props: IProps) => {
    const [applicationSuccess, setApplicationSuccess] = useState(false);
    const {unlockOffers, areOffersUnlocked, isPaywallVariant} = useCreditPaywallAbTest();

    useEffect(() => {
        if (!props.isOpen) {
            const timeout = setTimeout(() => {
                // reset steps
                setApplicationSuccess(false);
            }, 300); // wait for animation to finish

            return () => {
                clearTimeout(timeout);
            };
        }
    }, [props.isOpen]);

    const creditInfoTable = getCreditInfo(props.submitData);

    const onClose = (closedByButton?: boolean) => {
        props.onClose();
        if (!applicationSuccess) {
            CreditModalEvent({
                sent: closedByButton ? false : null,
                source_id: props.algolyticData.source,
                view_type: props.algolyticData.type
            });
        }
    };

    const onAfterSend = (isSuccess: boolean) => {
        CreditModalEvent({
            sent: true,
            source_id: props.algolyticData.source,
            view_type: props.algolyticData.type
        });

        if (props.gtmEvent) {
            sendCreditEvent(props.gtmEvent);
        }

        if (isSuccess !== applicationSuccess) {
            setApplicationSuccess(isSuccess);
        }

        // Unlock credit offers after successful form submission
        if (isSuccess) {
            unlockOffers();
        }
    };

    return (
        <Modal isOpen={props.isOpen} onModalClose={() => onClose()} className={modalStyle}>
            {applicationSuccess ? (
                <>
                    <Modal.Header />
                    <Modal.Content>
                        <div className={successContentStyle} data-testid={CREDIT_PAGES_IDS.COMMON.CREDIT_APPLICATION_MODAL}>
                            <div className={successTextStyle}>
                                <BrandCheckboxCheckedIcon wrapperSize="10" size="10" wrapperColor="var(--colors-primary)" />
                                <Text variant="headline_3" as="p">
                                    Twoje zapytanie zostało wysłane
                                </Text>
                            </div>
                            <Button variant="filled_primary" className={buttonStyle} onClick={() => onClose()}>
                                ok
                            </Button>
                        </div>
                    </Modal.Content>
                </>
            ) : (
                <>
                    <Modal.Header showCloseButton={false} className={headerStyle}>
                        <div className={headerContentStyle}>
                            {!areOffersUnlocked && isPaywallVariant ? (
                                <>
                                    <Text variant="headline_6">Zobacz pełne warunki kredytu</Text>
                                    <Text variant="body_copy_2" color="var(--colors-gray-700)">
                                        Podaj swoje dane, aby odkryć oprocentowanie, RRSO i szczegóły oferty dopasowane do Ciebie.
                                    </Text>
                                </>
                            ) : (
                                <>
                                    <Text variant="headline_6">Umów się na rozmowę</Text>
                                    <Text variant="body_copy_2" color="var(--colors-gray-700)">
                                        Skorzystaj z bezpłatnej porady kredytowej
                                    </Text>
                                </>
                            )}
                            <div onClick={() => onClose(true)} className={closeStyle}>
                                <CloseIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Content className={contentStyle}>
                        {creditInfoTable.length > 0 && <GreyInfoTable infoItems={creditInfoTable} />}

                        <CreditCalculatorForm
                            submitData={props.submitData}
                            onAfterSend={onAfterSend}
                            source={CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT}
                        />
                    </Modal.Content>
                </>
            )}
        </Modal>
    );
};

const modalStyle = css({
    overflow: "visible",
    padding: "2 0",
    md: {
        padding: 2,
        width: "55rem"
    }
});

const headerStyle = css({
    position: "relative"
});

const headerContentStyle = css({
    marginTop: 2,
    paddingRight: 5
});

const contentStyle = css({
    overflow: "visible"
});

const closeStyle = css({
    position: "absolute",
    padding: 2,
    top: 0,
    right: 0,
    cursor: "pointer"
});

const successContentStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
    gap: 5
});

const successTextStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 2
});

const buttonStyle = css({
    width: "100%"
});
